import React, {useState} from 'react';
import Popover from 'react-tiny-popover';

import ActionList from '../../../../../ActionList';
import {Platform} from '../../../../../../types';
import {addToQueue} from './icons';

import {ActionListItemDescriptor} from '../../../../../ActionList/types';
import useSearch from '../../../../../../hooks/useSearch';
import {useHistory} from 'react-router';
import styles from './SearchBar.module.scss';
import {useObsidianContext} from '../../../../../../context/ObsidianProvider';
import {useQueueContext} from '../../../../../../context/QueueProvider';

export default function SearchBar() {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const [searchResults, loading] = useSearch(searchTerm, 5);

  const {obsidian} = useObsidianContext();
  const {playNext, playLater} = useQueueContext();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // TODO: Make prettier & Add "no results found" state
  const loadingMarkup = loading ? (
    <div className={styles.Loading}>Loading</div>
  ) : (
    <p className={styles.Empty}>No results</p>
  );
  const searchResultsActionListItems: ActionListItemDescriptor[] = loading
    ? []
    : [
        ...searchResults!.slice(0, 8).map((result) => {
          return {
            id: result.id,
            content: result.name,
            image: result.artwork.smallUrl,
            options: [
              {
                id: 'playNext',
                icon: addToQueue,
                onClick: () => {
                  playNext(result);
                },
              },
              {
                id: 'playLater',
                icon: addToQueue,
                onClick: () => {
                  playLater(result);
                },
              },
            ],
            onAction: () => {
              obsidian.play(result, Platform.AppleMusic);
            },
          };
        }),
        {
          id: 'viewMore',
          content: 'View more results',
          highlight: true,
          onAction: () => {
            history.push(`/search/${searchTerm}`);
          },
        },
      ];

  return (
    <Popover
      position="bottom"
      align="center"
      isOpen={searchTerm ? searchTerm.length > 0 : false}
      content={
        searchResultsActionListItems.length > 1 ? (
          <ActionList items={searchResultsActionListItems} />
        ) : (
          loadingMarkup
        )
      }
      containerClassName={styles.Popover}
      onClickOutside={() => setSearchTerm('')}
      transitionDuration={0.15}
    >
      <input
        className={styles.SearchBar}
        placeholder="Search"
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            history.push(`/search/${searchTerm}`);
          }
        }}
        value={searchTerm ? searchTerm : undefined}
        onChange={handleChange}
      ></input>
    </Popover>
  );
}
